"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrampleAbilityHandler = exports.TrampleActorAbilityFactory = exports.TrampleAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Random_1 = require("../../utils/Random");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class TrampleAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Trample;
        this.__typeName = "Trample";
    }
}
exports.TrampleAbilityArgs = TrampleAbilityArgs;
let TrampleActorAbilityFactory = class TrampleActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Trample", "AllEnemies", 2);
    }
};
TrampleActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Trample")
], TrampleActorAbilityFactory);
exports.TrampleActorAbilityFactory = TrampleActorAbilityFactory;
let TrampleAbilityHandler = class TrampleAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const targets = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        container.applyMultiAttack({
            attackerId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            sequence,
            targets: targets.map((targetId, i) => ({
                targetId,
                jitter: (0, Random_1.random)(25, 75),
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Physical", 60)
                ],
                effects: [
                    (0, Random_1.randomPercent)() <= 50 && {
                        targetId,
                        duration: Duration_1.Duration.Turns(1),
                        effect: new core_1.StunEffectArgs()
                    }
                ].filter(Boolean)
            }))
        });
    }
};
TrampleAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Trample)
], TrampleAbilityHandler);
exports.TrampleAbilityHandler = TrampleAbilityHandler;
